import { Star, Quote } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const REVIEWS = [
  {
    quote:
      "The thatta podi ghee idli took me straight back to my grandmother's kitchen in Kumbakonam. Rare authenticity this side of the Vindhyas.",
    name: "Meera Raghavan",
    tag: "Food Blogger, Gurugram",
  },
  {
    quote:
      "Crispiest benne dosa I have had in NCR, hands down. The sambaram alone is worth the drive to Sohna.",
    name: "Arjun Mehta",
    tag: "Regular since opening week",
  },
  {
    quote:
      "Finally a pure-veg South Indian spot that cuts no corners. Fresh batter, real ghee, honest prices — the ₹300-for-two promise holds.",
    name: "Kavitha Iyer",
    tag: "Sohna resident",
  },
];

const Testimonials = () => (
  <section id="reviews" data-testid="testimonials-section" className="relative py-24 sm:py-32">
    <div className="pointer-events-none absolute right-0 top-1/3 h-[360px] w-[360px] rounded-full bg-[#388E3C]/8 blur-[120px]" />
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="text-center">
        <Eyebrow>Word of Mouth</Eyebrow>
        <h2 className="mx-auto mt-4 max-w-2xl font-display text-3xl font-medium leading-tight tracking-tight sm:text-4xl md:text-5xl">
          Loved by Gurgaon's
          <span className="text-gradient-leaf italic"> South Indian food faithful.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={0.1 * i}>
            <blockquote
              data-testid={`testimonial-card-${i}`}
              className="card-surface flex h-full flex-col rounded-3xl p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-[#D4AF37]/40"
            >
              <Quote size={26} className="text-[#F57C00]/60" />
              <div className="mt-4 flex gap-1">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={14} className="fill-[#D4AF37] text-[#D4AF37]" />
                ))}
              </div>
              <p className="mt-4 flex-1 text-base leading-relaxed text-zinc-300">
                "{r.quote}"
              </p>
              <footer className="mt-6 border-t border-white/8 pt-4">
                <p className="font-grotesk text-sm font-semibold text-[#F5F2EB]">{r.name}</p>
                <p className="mt-0.5 font-mono-accent text-[11px] uppercase tracking-widest text-zinc-500">
                  {r.tag}
                </p>
              </footer>
            </blockquote>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
